/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CloudAccountComplianceSummaryWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CloudAccountComplianceSummaryWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CloudAccountComplianceSummaryWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CloudAccountComplianceSummaryWidgetConfiguration>): CloudAccountComplianceSummaryWidgetConfiguration {
        let obj = Object.assign(new CloudAccountComplianceSummaryWidgetConfiguration(), model);
        CloudAccountComplianceSummaryWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CloudAccountComplianceSummaryWidgetConfiguration>): CloudAccountComplianceSummaryWidgetConfiguration {
        if (!model) return null;
        return CloudAccountComplianceSummaryWidgetConfiguration.newInstance(<CloudAccountComplianceSummaryWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CloudAccountComplianceSummaryWidgetConfiguration) {
        if (!obj) return;

        models.CloudAccountComplianceSummaryWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CloudAccountComplianceSummaryWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CloudAccountComplianceSummaryWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
